import React from "react"

const TimelineSpacer = () => {
  return <div className="w-1 bg-primary-100 h-8 m-auto"></div>
}

export default TimelineSpacer
